import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Apply the saved theme before first paint so dark mode doesn't flash white.
// Scoped to the app (/app/*) — public pages (landing, login) have their own
// fixed design and must not inherit the dark remap.
if (localStorage.getItem('theme') === 'dark' && window.location.pathname.startsWith('/app')) {
  document.documentElement.classList.add('dark');
}

// Single entry point: the modern React-Router app (App.tsx) mounted at root.
// (The old ~9k-line sidebar "classic" UI that used to live here was retired —
// it was dead code served at / while the real app hid under /modern.)
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
